'use client';

import { useEffect } from 'react';

import { initClientLogging } from 'src/lib/logger.client';

/**
 * Hook koji inicijalizira client-side error logging.
 *
 * @deprecated Koristi direktno initClientLogging() u _app.tsx ili root layout-u.
 */
export default function useClientErrorLogging() {
  useEffect(() => {
    initClientLogging();
  }, []);
}
